import React, { Component } from 'react'
import Snapshot from './Snapshot'
import { getPatientSnapshot } from '../../api'
import moment from 'moment-timezone'
import { DEFAULT_TIMEZONE } from '../../constants'

class SnapshotList extends Component {
  constructor (props) {
    super(props)

    this.state = {
      dates: [
        moment.tz(this.props.date, DEFAULT_TIMEZONE),
        moment.tz(this.props.date, DEFAULT_TIMEZONE).subtract('1', 'days'),
        moment.tz(this.props.date, DEFAULT_TIMEZONE).subtract('2', 'days'),
        moment.tz(this.props.date, DEFAULT_TIMEZONE).subtract('3', 'days'),
        moment.tz(this.props.date, DEFAULT_TIMEZONE).subtract('4', 'days'),
        moment.tz(this.props.date, DEFAULT_TIMEZONE).subtract('5', 'days'),
        moment.tz(this.props.date, DEFAULT_TIMEZONE).subtract('6', 'days'),
      ]
    }
  }

  componentDidMount () {
    getPatientSnapshot(this.props.patient.id, this.state.dates).then(response => this.setState({snapshots: response}))
  }

  componentWillReceiveProps (newProps) {
    this.setState({
      dates: [
        moment.tz(newProps.date, DEFAULT_TIMEZONE),
        moment.tz(newProps.date, DEFAULT_TIMEZONE).subtract('1', 'days'),
        moment.tz(newProps.date, DEFAULT_TIMEZONE).subtract('2', 'days'),
        moment.tz(newProps.date, DEFAULT_TIMEZONE).subtract('3', 'days'),
        moment.tz(newProps.date, DEFAULT_TIMEZONE).subtract('4', 'days'),
        moment.tz(newProps.date, DEFAULT_TIMEZONE).subtract('5', 'days'),
        moment.tz(newProps.date, DEFAULT_TIMEZONE).subtract('6', 'days'),
      ]
    }, () => {
      getPatientSnapshot(this.props.patient.id, this.state.dates).then(response => this.setState({snapshots: response}))
    })
  }

  render () {
    const { timelineDate, date, onClick } = this.props
    const { snapshots } = this.state
    const sameDate = (d1, d2) => d1.isSame(d2, 'date')

    if (!snapshots) return <div/>
    return (
      <div>
        { snapshots.map((snapshot, index) => <Snapshot snapshot={snapshot} active={sameDate(timelineDate, this.state.dates[index])} onClick={e => onClick(this.state.dates[index])} />) }
      </div>
    )
  }
}

export default SnapshotList



// WEBPACK FOOTER //
// ./src/components/SnapshotList/SnapshotList.js